import { DaSelectedCourse } from '../../../src_server/entity/generated/DaSelectedCourse';


import { StudentInfoInputDTO } from '../../../src_server/entity/dto/StudentInfoInputDTO';


import { UserAuth } from '../../../src_server/entity/generated/UserAuth';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class StudentService extends GeneratedBizBase{
  async getDaStudentSelectedCourse(student_user_id: string): Promise<Response<DaSelectedCourse[]>> {
    return super.restCall<Response<DaSelectedCourse[]>>('get', '/v1/getDaStudentSelectedCourse', arguments);
  }
  async getStudentByUserId(user_id: string): Promise<Response<StudentInfoInputDTO>> {
    return super.restCall<Response<StudentInfoInputDTO>>('get', '/v1/getStudentByUserId', arguments);
  }
  async getAll_da(building_id: string): Promise<Response<StudentInfoInputDTO[]>> {
    return super.restCall<Response<StudentInfoInputDTO[]>>('get', '/v1/getAll_da', arguments);
  }
  async getAll(building_id: string): Promise<Response<StudentInfoInputDTO[]>> {
    return super.restCall<Response<StudentInfoInputDTO[]>>('get', '/v1/getAll', arguments);
  }
  async getKpCsvViewInitList(building_id: string): Promise<Response<StudentInfoInputDTO[]>> {
    return super.restCall<Response<StudentInfoInputDTO[]>>('get', '/v1/StudentService/getKpCsvViewInitList', arguments);
  }
  async setStudentInfo(user_id: string,dto: StudentInfoInputDTO,building_id: string): Promise<Response<StudentInfoInputDTO>> {
    return super.restCall<Response<StudentInfoInputDTO>>('post', '/v1/setStudentInfo', arguments);
  }
  async maintenanceUpdate(user_id: string,building_id: string,dto: StudentInfoInputDTO): Promise<Response<StudentInfoInputDTO>> {
    return super.restCall<Response<StudentInfoInputDTO>>('post', '/v1/maintenanceUpdate', arguments);
  }
  async deleteStudent(user_id: string): Promise<Response<boolean>> {
    return super.restCall<Response<boolean>>('post', '/v1/deleteStudent', arguments);
  }
  async getAllStudentInBuilding(building_id: string): Promise<Response<UserAuth[]>> {
    return super.restCall<Response<UserAuth[]>>('post', '/v1/StudentService/getAllStudentInBuilding', arguments);
  }
}
